import type { ProfileImageResponse } from '@shared/api-utils';
import { imagePathResolver, ROUTES } from '@shared/utils';
import type { Person, WithContext } from 'schema-dts';
import { JsonLd } from '../../JsonLd/JsonLd';

type MagazineAuthorPersonJsonLdProps = {
  name: string;
  authorSlug: string;
  baseUrl: string;
  baseImgUrl: string;
  /** Plain-text SEO description — never raw HTML bio. */
  description?: string;
  profilePicture?: ProfileImageResponse;
};

function MagazineAuthorPersonJsonLd({ name, authorSlug, baseUrl, baseImgUrl, description, profilePicture }: MagazineAuthorPersonJsonLdProps) {
  const authorUrl = `${baseUrl}${ROUTES.MAGAZINE.AUTHOR.replace(':authorSlug', authorSlug)}`;
  const image = profilePicture?.filePath ? imagePathResolver(profilePicture.filePath, baseImgUrl) : undefined;

  const person: WithContext<Person> = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name,
    url: authorUrl,
    mainEntityOfPage: authorUrl,
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
  };

  return <JsonLd json={person} />;
}

export { MagazineAuthorPersonJsonLd, type MagazineAuthorPersonJsonLdProps };
